var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#142654",
    d: "m10.47 13.26 6.3-3.87-6.3-3.87v7.74ZM24.5 3.16c.16.6.27 1.42.34 2.45a33 33 0 0 1 .12 2.7l.07 1.08c0 2.82-.19 4.9-.53 6.23-.3 1.16-1 1.91-2.1 2.23-.57.17-1.61.29-3.22.36-1.57.1-3.02.13-4.35.13l-1.93.08c-5.09 0-8.25-.2-9.5-.57a2.94 2.94 0 0 1-2.1-2.23c-.16-.6-.27-1.42-.34-2.45a32.97 32.97 0 0 1-.12-2.7L.76 9.4c0-2.83.2-4.9.54-6.23C1.6 2 2.3 1.25 3.4.93 3.97.76 5 .64 6.6.57 8.2.47 9.63.44 10.97.44L12.9.36c5.08 0 8.25.2 9.5.57 1.1.32 1.8 1.07 2.1 2.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.98c6f564a2fd74d329ede1ce36b3f70a.svg";
export { ForwardRef as ReactComponent };